/* eslint-disable perfectionist/sort-objects */
import { defineTokens } from "../../core"

export const zIndices = defineTokens.zIndices({
  yamcha: 1,
  kurillin: 9,
  nappa: 99,

  guldo: 100,
  jeice: 110,
  burter: 120,
  recoome: 130,
  ginyu: 140,
  dodoria: 150,
  zarbon: 160,

  freeza: 9996,
  vegeta: 9997,
  sonGoku: 9998,
  beerus: 9999,
})
